<template>
	<div id="app">
		<router-view></router-view>

		<add-subscribe-order
			v-if="!showSupplierForm"
			:isShowSubscribe.sync="FisShowSubscribe"
			:subscribeOrder.sync="FsubscribeOrder"
			:isEdit="FisEdit"
			:isLook="FisLook"
			:isApprove="FisApprove"
			:isnotify="Fisnotify"
			:auditid="Fauditid"
			@closeSubscribe="FcloseSubscribe"
		></add-subscribe-order>

		<add-purchase-order
			v-if="!showSupplierForm"
			:isShowPurchase.sync="FisShowPurchase"
			:purchaseorder.sync="FpurchaseOrder"
			:isEdita="FisEdita"
			:isLooka="FisLooka"
			:isnotify="Fisnotify"
			:auditid="Fauditid"
			@closePurchase="FclosePurchase"
		></add-purchase-order>

		<add-pay-order
			v-if="!showSupplierForm"
			:isShowPay.sync="FisShowPay"
			:payorder.sync="FpayOrder"
			:isEditb="FisEditb"
			:isLookb="FisLookb"
			:isPurchb="FisPurch"
			:isnotify="Fisnotify"
			:auditid="Fauditid"
			@closePay="FclosePay"
		></add-pay-order>
	</div>
</template>
<script>
const debug = process.env.NODE_ENV !== 'production';
import personelApi from '@/request/personelApi';
import wmsApi from '@/request/wmsApi';
import baseFunction from '@/utils/baseFunction';
import financialApi from '@/request/financialApi';
import AddSubscribeOrder from './components/common/PurchasingManagement/AddSubscribeOrder';
import AddPurchaseOrder from './components/common/PurchasingManagement/AddPurchaseOrder';
import AddPayOrder from './components/common/PurchasingManagement/AddPaymentOrder';

import getToken from './utils/baseFunction';
import bus from '@/components/common/bus';
import userApi from './request/userApi';
import { mapState } from 'vuex';
import $ from 'jquery';
import config from '@/utils/config';
// import qs from 'QS';
export default {
	name: 'App',
	components: {
		AddSubscribeOrder,
		AddPurchaseOrder,
		AddPayOrder
	},
	data() {
		return {
			showSupplierForm: false,
			webSocket: null,
			showMsg: '',
			notifyobj: {},
			socketReconnTime: 0,
			reconn: '',

			FisShowSubscribe: false,
			FsubscribeOrder: {},
			FisEdit: false,
			FisLook: false,
			FisShowPurchase: false,
			FpurchaseOrder: [],
			FisEdita: false,
			FisLooka: false,
			FisShowPay: false,
			FpayOrder: {},
			FisEditb: false,
			FisLookb: false,
			FisPurch: false,
			Fisnotify: true,
			Fauditid: 0,
			FisApprove: false,
			treedata: []
		};
	},
	activated() {
		// let child = [];
		// (module =>
		// 	module.keys().forEach(key => {
		// 		child = child.concat(module(key).default);
		// 	}))(require.context('@static/cmaps/', true, /78\.bcmap$/));
		// console.log(child);
		// this.$i18n.locale = 'en';
	},
	async created() {
		console.log(this.$router);
		let redirObj = { toUrl: this.$router.history._startLocation, isProcess: false };
		console.log(redirObj);
		// console.log(process.env.NODE_ENV);
		document.getElementsByTagName('title')[0].innerText =
			process.env.NODE_ENV === 'release' || process.env.NODE_ENV === 'tmkRelease' ? 'Purchase System (Official)' : 'Purchase System (developer)';

		// if (redirObj.toUrl !== '/' && redirObj.toUrl !== '/login') {
		if (redirObj.toUrl.indexOf('/?redir=') !== -1) {
			// 记录要跳转的路由
			redirObj.toUrl = redirObj.toUrl.replace('?redir=', '');
			this.$cookies.set('redir', redirObj, '1D');
		}
		// console.log(this.$router.history._startLocation.indexOf('supplierform') != -1);
		if (this.$router.history._startLocation.indexOf('supplier_form') != -1) {
			this.showSupplierForm = true;
			return;
		}
		// 从cookies读取用户信息
		let loginData = this.$cookies.get('userData');
		if (loginData && loginData != '') {
			// 有登陆信息
			this.$store.commit('user/setData', { userData: loginData, token: loginData.tokenData.token, authtoken: loginData.tokenData.token, loginSuccess: true });
			// this.$store.commit('user/setData', { userData: loginData, token: loginData.auth_token, loginSuccess: true });
			console.log('cookies get userData=>', this.userData);
			this.$router.replace('/');

			// 环境的切换
			if (process.env.NODE_ENV === 'development') {
				// 开发
				this.$connection.baseUrl = config.devSignalrHost;
			} else if (process.env.NODE_ENV === 'production') {
				//生产
				this.$connection.baseUrl = config.proSignalrHost;
			} else if (process.env.NODE_ENV === 'release') {
				// 越南正式环境
				this.$connection.baseUrl = config.releaseSignalrHost;
			}
			this.$connection.baseUrl += '?token=' + loginData.tokenData.token;
			// this.$connection.baseUrl = 'http://47.243.31.121:1000/signalr?token=' + loginData.tokenData.token;
			// this.$connection.baseUrl = 'https://oaapi.tmi.com.vn/signalr?token=' + loginData.tokenData.token;
			this.getMessage();
			this.PurchaseRequestionApproval();
			this.PurchaseOrderApproval();
			this.ApplicationPayApproval();
			this.PurchaseRequestionApprovalResult();
			this.PurchaseOrderApprovalResult();
			this.ApplicationPayApprovalResult();
			this.GetDepartList();
			this.webSocketReconn(loginData.tokenData.token);
			this.$connection.start();
			// this.getCheckAppUpdate();
			// this.sendMessage();
		} else {
			// 无登陆信息
			this.$router.replace('/login');
		}
	},
	methods: {
		FclosePay() {
			this.FpayOrder = {};
			this.FisShowPay = false;
			this.Fisnotify = false;
		},

		FcloseSubscribe() {
			this.FsubscribeOrder = {};
			this.FisShowSubscribe = false;
			this.Fisnotify = false;
		},

		FclosePurchase() {
			this.FpurchaseOrder = [];
			this.FisShowPurchase = false;
			this.Fisnotify = false;
		},

		getMessage() {
			var that = this;
			console.log('this.$connection', this.$connection);

			this.$connection.on('SendTextMessage', (data) => {
				console.log('data', data);
				this.$confirm(data.title, this.$t('header.tishi'), {
					confirmButtonText: this.$t('header.confirmButtonText'),
					showCancelButton: false,
					type: 'info'
				})
					.then(() => {
						// this.$message({
						// 	type: 'success',
						// 	message: '删除成功!'
						// });
					})
					.catch(() => {});
			});
		},

		//审核
		PurchaseRequestionApproval() {
			var that = this;
			this.$connection.on('PurchaseRequestionApproval', (data) => {
				console.log('PurchaseRequestionApproval', data);
				var notifyitem = this.$notify({
					title: data.title,
					message: data.content,
					duration: 0,
					iconClass: 'el-icon-s-order',
					showClose: true,
					position: 'bottom-right',
					onClick() {
						that.jump(notifyitem.id, 'PurchaseRequestionApproval', data.functionArgs);
					}
				});
				// console.log('notifyitem',notifyitem);
				this.notifyobj[notifyitem.id] = notifyitem;
			});
		},

		PurchaseOrderApproval() {
			var that = this;
			this.$connection.on('PurchaseOrderApproval', (data) => {
				console.log('PurchaseOrderApproval', data);
				var notifyitem = this.$notify({
					title: data.title,
					message: data.content,
					duration: 0,
					iconClass: 'el-icon-s-management',
					showClose: true,
					position: 'bottom-right',
					onClick() {
						that.jump(notifyitem.id, 'PurchaseOrderApproval', data.functionArgs);
					}
				});
				// console.log('notifyitem',notifyitem);
				this.notifyobj[notifyitem.id] = notifyitem;
			});
		},

		ApplicationPayApproval() {
			var that = this;
			this.$connection.on('ApplicationPayApproval', (data) => {
				console.log('ApplicationPayApproval', data);
				var notifyitem = this.$notify({
					title: data.title,
					message: data.content,
					showClose: true,
					duration: 0,
					iconClass: 'el-icon-s-flag',
					position: 'bottom-right',
					onClick() {
						that.jump(notifyitem.id, 'ApplicationPayApproval', data.functionArgs);
					}
				});
				// console.log('notifyitem',notifyitem);
				this.notifyobj[notifyitem.id] = notifyitem;
			});
		},
		//列表
		PurchaseRequestionApprovalResult() {
			var that = this;
			this.$connection.on('PurchaseRequestionApprovalResult', (data) => {
				console.log('PurchaseRequestionApprovalResult', data);
				var notifyitem = this.$notify({
					title: data.title,
					message: data.content,
					showClose: true,
					duration: 0,
					iconClass: 'el-icon-s-claim',
					position: 'bottom-right',
					onClick() {
						that.jump(notifyitem.id, 'PurchaseRequestionApprovalResult', data.functionArgs);
					}
				});
				// console.log('notifyitem',notifyitem);
				this.notifyobj[notifyitem.id] = notifyitem;
			});
		},

		PurchaseOrderApprovalResult() {
			var that = this;
			this.$connection.on('PurchaseOrderApprovalResult', (data) => {
				console.log('PurchaseOrderApprovalResult', data);
				var notifyitem = this.$notify({
					title: data.title,
					message: data.content,
					showClose: true,
					duration: 0,
					iconClass: 'el-icon-message-solid',
					position: 'bottom-right',
					onClick() {
						that.jump(notifyitem.id, 'PurchaseOrderApprovalResult', data.functionArgs);
					}
				});
				// console.log('notifyitem',notifyitem);
				this.notifyobj[notifyitem.id] = notifyitem;
			});
		},

		ApplicationPayApprovalResult() {
			var that = this;
			this.$connection.on('ApplicationPayApprovalResult', (data) => {
				console.log('ApplicationPayApprovalResult', data);
				var notifyitem = this.$notify({
					title: data.title,
					message: data.content,
					showClose: true,
					duration: 0,
					iconClass: 'el-icon-s-opportunity',
					position: 'bottom-right',
					onClick() {
						that.jump(notifyitem.id, 'ApplicationPayApprovalResult', data.functionArgs);
					}
				});
				// console.log('notifyitem',notifyitem);
				this.notifyobj[notifyitem.id] = notifyitem;
			});
		},

		ProjectApproval() {
			var that = this;
			this.$connection.on('ProjectApproval', (data) => {
				console.log('ProjectApproval', data);
				var notifyitem = this.$notify({
					title: data.title,
					message: data.content,
					showClose: true,
					duration: 0,
					iconClass: 'el-icon-tickets',
					position: 'bottom-right',
					onClick() {
						that.jump(notifyitem.id, 'ProjectApproval', data.functionArgs);
					}
				});
				// console.log('notifyitem',notifyitem);
				this.notifyobj[notifyitem.id] = notifyitem;
			});
		},

		// sendMessage() {
		// 	this.$connection.invoke('SendTextMessage', {
		// 		name: 'a',
		// 		message: 'b'
		// 	});
		// },

		async start() {
			try {
				await this.$connection.start();
				console.log('SignalR Connected.');
				console.log('this.$connection->', this.$connection);
			} catch (err) {
				console.log('Connection Error->', err);
				setTimeout(() => {
					this.start();
				}, 5000);
			}
		},

		webSocketReconn(token) {
			var that = this;

			this.$connection.onclose(async () => {
				console.log('on close->', this.$connection);
				await this.start();
			});

			// connection.onreconnecting(error => {
			//     console.assert(connection.state === signalR.HubConnectionState.Reconnecting);

			//     document.getElementById("messageInput").disabled = true;

			//     const li = document.createElement("li");
			//     li.textContent = `Connection lost due to error "${error}". Reconnecting.`;
			//     document.getElementById("messagesList").appendChild(li);
			// });

			// that.$connection.disconnected(() =>{
			//     if (that.$connection.lastError) {
			// 			alert("Disconnected. Reason: " +  that.$connection.lastError.message);
			// 		}

			// 		that.socketReconnTime += 5000;
			// 		that.reconn = setInterval(() => {
			// 			// if (that.socketReconnTime >= 60000) {
			// 			if (that.socketReconnTime >= 20000) {
			// 				console.log('重连次数用完');
			// 				clearInterval(that.reconn);
			// 				that.$connection.stop().then(() => {
			// 					console.log('this.$connection',this.$connection);
			// 					console.log('关闭连接');
			// 				});
			// 				return;
			// 			}
			// 			that.$connection.start();
			// 		}, 5000);
			// });

			// that.$connection.onclose(() => {
			// 	console.log('this.$connection',this.$connection);
			// 	console.log('断开连接');
			// 	that.socketReconnTime += 5000;
			// 	that.reconn = setInterval(() => {
			// 		// if (that.socketReconnTime >= 60000) {
			// 		if (that.socketReconnTime >= 20000) {
			// 			console.log('重连次数用完');
			// 			clearInterval(that.reconn);
			// 			that.$connection.stop().then(() => {
			// 				console.log('this.$connection',this.$connection);
			// 				console.log('关闭连接');
			// 			});
			// 			return;
			// 		}
			// 		that.$connection.baseUrl = 'http://47.243.31.121:1000/signalr?token='+token;
			// 		that.getMessage();
			// 		that.$connection.start();
			// 	}, 5000);
			// 	// console.log('that.socketReconnTime=>',that.socketReconnTime)
			// })
		},

		async GetDepartList() {
			this.treedata = [];
			let treeListRes = await personelApi.GetDepartList(this.token, 1);
			// console.log('treeListRes: ', treeListRes);
			if (treeListRes.errMsg === 'success!') {
				this.treedata = treeListRes.data;
			}
		},

		async jump(index, type, num) {
			// console.log('index',index,this.notifyobj);
			this.notifyobj[index].close();
			delete this.notifyobj[index];

			console.log('num: ', num);

			if (type == 'PurchaseRequestionApprovalResult') {
				bus.$emit('opentag', ['/subscribe', this.$t('Sidebar.wmssubsTitle[4]'), { keyword: num[0] }, 'subscribe']);
			} else if (type == 'PurchaseOrderApprovalResult' || type == 'ApplicationPayApprovalResult') {
				bus.$emit('opentag', ['/purchase', this.$t('Sidebar.wmssubsTitle[5]'), { keyword: num[0] }, 'purchase']);
			} else if (type == 'ProjectApproval') {
				bus.$emit('opentag', ['/Processauditdocumentsaudit', this.$t('Sidebar.processaudit[2]'), { documenttype: 'project' }, 'Processauditdocumentsaudit']);
			} else if (type == 'PurchaseRequestionApproval') {
				let infoRes = await wmsApi.GetSubscribeInfo(this.token, num[0]);
				console.log('infoRes: ', infoRes);

				if (infoRes.data.applydt != null && infoRes.data.applydt != '') {
					infoRes.data.applydt = baseFunction.formatterDate(infoRes.data.applydt);
				}

				this.treedata.forEach((treeobj, index) => {
					if (treeobj.id === infoRes.data.deptid) {
						infoRes.data.deptname = treeobj.name;
					}
				});

				if (infoRes.data.budgetMoney != 0) {
					infoRes.data.budgetMoney = infoRes.data.budgetMoney.toFixed(2);
				}

				infoRes.data.money += '';
				if (!infoRes.data.money.includes('.')) infoRes.data.money += '.';
				infoRes.data.money = infoRes.data.money
					.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
						return $1 + ',';
					})
					.replace(/\.$/, '');

				infoRes.data.budgetMoney += '';
				if (!infoRes.data.budgetMoney.includes('.')) infoRes.data.budgetMoney += '.';
				infoRes.data.budgetMoney = infoRes.data.budgetMoney
					.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
						return $1 + ',';
					})
					.replace(/\.$/, '');

				infoRes.data.GoodsList.forEach((itemGoods) => {
					itemGoods.Goods.priceList.forEach((priceObj) => {
						if (priceObj.isUsed === 1) itemGoods.shortEng = priceObj.currency;
					});
					itemGoods.num = itemGoods.Goods.num;
					itemGoods.name = itemGoods.Goods.name;
				});

				this.FsubscribeOrder = infoRes.data;
				this.FisEdit = true;
				this.FisLook = true;
				this.FisApprove = true;
				this.FisShowSubscribe = true;
				this.Fisnotify = true;
				this.Fauditid = num[2];
			} else if (type == 'PurchaseOrderApproval') {
				let purchaseRes = await wmsApi.GetPurchaseInfo(this.token, num[0]);
				console.log('purchaseRes: ', purchaseRes);

				if (purchaseRes.data.applydt != null && purchaseRes.data.applydt != '') {
					purchaseRes.data.applydt = baseFunction.formatterDate(purchaseRes.data.applydt);
				}

				if (purchaseRes.data.ShipmanDate != null && purchaseRes.data.ShipmanDate != '') {
					purchaseRes.data.ShipmanDate = baseFunction.formatterDate(purchaseRes.data.ShipmanDate);
				}

				if (purchaseRes.data.optdt != null && purchaseRes.data.optdt != '') {
					purchaseRes.data.optdt = baseFunction.formatterDate(purchaseRes.data.optdt);
				}

				purchaseRes.data.money += '';
				if (!purchaseRes.data.money.includes('.')) purchaseRes.data.money += '.';
				purchaseRes.data.money = purchaseRes.data.money
					.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
						return $1 + ',';
					})
					.replace(/\.$/, '');

				purchaseRes.data.totalAmount += '';
				if (!purchaseRes.data.totalAmount.includes('.')) purchaseRes.data.totalAmount += '.';
				purchaseRes.data.totalAmount = purchaseRes.data.totalAmount
					.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
						return $1 + ',';
					})
					.replace(/\.$/, '');

				purchaseRes.data.Tax += '';
				if (!purchaseRes.data.Tax.includes('.')) purchaseRes.data.Tax += '.';
				purchaseRes.data.Tax = purchaseRes.data.Tax.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
					return $1 + ',';
				}).replace(/\.$/, '');

				// purchaseRes.data.discount += '';
				// if (!purchaseRes.data.discount.includes('.')) purchaseRes.data.discount += '.';
				// purchaseRes.data.discount =  purchaseRes.data.discount.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {return $1 + ',';}).replace(/\.$/, '');

				purchaseRes.data.sourceMoney = purchaseRes.data.money;

				this.FpurchaseOrder = purchaseRes.data;
				this.FisEdita = true;
				this.FisLooka = true;
				this.FisShowPurchase = true;
				this.Fisnotify = true;
				this.Fauditid = num[2];
			} else if (type == 'ApplicationPayApproval') {
				let payRes = await financialApi.GetApplyPayInfo(this.token, num[0]);
				console.log('payRes: ', payRes);

				payRes.data.isUseDetail = false;

				if (payRes.data.itemList && payRes.data.itemList.length > 0) payRes.data.isUseDetail = true;

				payRes.data.money += '';
				if (!payRes.data.money.includes('.')) payRes.data.money += '.';
				payRes.data.money = payRes.data.money
					.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
						return $1 + ',';
					})
					.replace(/\.$/, '');

				payRes.data.totalAmount += '';
				if (!payRes.data.totalAmount.includes('.')) payRes.data.totalAmount += '.';
				payRes.data.totalAmount = payRes.data.totalAmount
					.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
						return $1 + ',';
					})
					.replace(/\.$/, '');

				payRes.data.Tax += '';
				if (!payRes.data.Tax.includes('.')) payRes.data.Tax += '.';
				payRes.data.Tax = payRes.data.Tax.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
					return $1 + ',';
				}).replace(/\.$/, '');

				if (payRes.data.applydt != null && payRes.data.applydt != '') {
					payRes.data.applydt = baseFunction.formatterDate(payRes.data.applydt);
				}
				payRes.data.ispaystate = payRes.data.payState == 0 ? this.$t('pay.name[3]') : this.$t('pay.name[4]');

				this.FpayOrder = payRes.data;
				console.log(this.FpayOrder);
				this.FisEditb = false;
				this.FisLookb = true;
				this.FisPurch = true;
				this.FisShowPay = true;
				this.Fisnotify = true;
				this.Fauditid = num[2];
			}
		}
	},
	computed: mapState({
		token: (state) => state.user.token,
		userData: (state) => state.user.userData
	})
};
</script>
<style>
@import './assets/css/main.css';
@import './assets/css/color-dark.css';
/*深色主题*/
/*@import "./assets/css/theme-green/color-green.css";   浅绿色主题*/
</style>



// WEBPACK FOOTER //
// src/App.vue